<script>
	import { topNavigationWidth } from '../share/stores';

	import { onMount } from 'svelte';

	import TopNavigationFooter from '../components/TopNavigationFooter.svelte';
	import NavListElement from '../helpers/NavListElement.svelte';

	let navDiv;

	function setTopNavigationWidth() {
		if(window.getComputedStyle(navDiv, null).display !== 'none') {
			topNavigationWidth.set(navDiv.getBoundingClientRect().width);
		}
		requestAnimationFrame(setTopNavigationWidth);
	}

	onMount(() => {
		setTopNavigationWidth();
	});
</script>


<div bind:this={navDiv}>
	<nav>
		<ul>
			<NavListElement url="agentur" text="Agentur"/>
			<NavListElement url="agentur" text="BurgEins"/>
			<NavListElement url="agentur/jobs" text="Jobs"/>
			<NavListElement url="agentur/kontakt" text="Kontakt"/>
		</ul>
		<ul>
			<NavListElement url="expertise_design" text="Expertise"/>
			<NavListElement url="expertise_design" text="Design"/>
			<NavListElement url="expertise_technologie" text="Technologie"/>
		</ul>
		<ul>
			<NavListElement url="portfolio" text="Portfolio"/>
			<NavListElement url="portfolio/appetit_digitalisieren" text="Appetit digitalisieren"/>
			<NavListElement url="portfolio/ueberflieger" text="Überflieger"/>
			<NavListElement url="portfolio/menschen_bewegen" text="Menschen bewegen"/>
			<NavListElement url="portfolio/stream_on" text="Stream On"/>
			<NavListElement url="portfolio/weltweit_regional" text="weltweit regional"/>
			<NavListElement url="portfolio/kein_mittelmass" text="Kein Mittelmaß"/>
			<NavListElement url="portfolio/individuelle_klasse" text="individuell(e) Klasse"/>
			<NavListElement url="portfolio/health_and_care" text="Health & Care"/>
			<NavListElement url="portfolio/burgeins_stromert" text="BurgEins stromert"/>
			<NavListElement url="portfolio/opel_case_study" text="Opel Case Study"/>
			<NavListElement url="portfolio/aes_hub" text="AES HUB"/>
		</ul>
	</nav>

	<TopNavigationFooter/>
</div>
<!--{/if}-->

<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";

	div {
		order: 1;
		position: relative;
		width: max-content;
		background-color: black;
		font-weight: lighter;
		color: white;
		z-index: 100;
		display: none;

		@include for-tablet-landscape-up {
			display: grid;
			grid-template-rows: 1fr auto;
			flex: var(--top-navigation-width) 0 0;
		}

		nav {
			display: flex;
			flex-flow: row;
			//padding: calc(var(--spacing-mobile) * 2) 4rem 5rem 4rem;
			padding: calc(var(--spacing-mobile) * 2) 9.9rem 0 8.875rem;
			gap: px-to-em(75);

			@include for-phone-only {
				justify-content: space-evenly;
			}

			ul {
				list-style: none;
				flex-direction: column;
				align-items: stretch;

				:global(li) {
					color: rgba(255, 255, 255, 0.65);
					transition: color .2s ease-in-out;
					text-align: left;
					white-space: nowrap;
					margin-bottom: 0;
					line-height: 3rem;
				}


				:global(li.stretch) {
					flex-grow: 1;
					width: auto;
				}

				:global(li a) {
					font-size: 2.2rem;
					line-height: 3rem;
					text-decoration: underline;
				}

				:global(li:first-of-type) {
					font-weight: normal;
					color: white;
					display: block;
					margin-bottom: 3rem;
				}

				:global(li:first-of-type a) {
					text-decoration: none;
					font-weight: 600;
				}

				:global(li:first-of-type a span) {
					font-weight: 100;
				}

				:global(li:first-of-type span) {
					font-weight: lighter;
					font-style: italic;
				}
			}

			:global(.active), :global(:hover) {
				color: white !important;
			}
		}
	}
</style>
